import { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { mtFindPersonJumio } from "../api/mtFindPersonJumio";
import { mtfindCpvIdJumio } from "../api/mtfindCpvIdJumio";
import { mtfindCpvIdImgLaboral } from "../api/mtfindCpvIdImgLaboral";
import { generarImagenReporte } from "../api/generarImagenReporte";
import { testDownloadFileSegundaHoja_Jumio } from "../api/testDownloadFileSegundaHoja_Jumio";
import { testDownloadFile_Jumio } from "../api/testDownloadFile_Jumio";
import { jsPDF } from "jspdf";
import Modal from 'react-bootstrap/Modal';
import "./print.css";
import "./style.css";
import jsQR from "jsqr";

function N5BLaboral_Jumio() {

    const componentRef = useRef(null);
    const isRunned = useRef(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [modalShow, setModalShow] = useState(false);
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [imagenFront, setImagenFront] = useState("");
    const [imagenBack, setImagenBack] = useState("");

    /*---Nombre reporte---*/

    const date = new Date();

    const formattedDate = date.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');
    const [cpv, setCpv] = useState(params.get("i"));

    /*---------------------------*/

    const [vigenciaCpv, setVigenciaCpv] = useState("");
    const [robos, setRobos] = useState("");
    const [accidentes, setAccidentes] = useState("");
    const [distancias, setDistancias] = useState("");
    const [conduccion, setConduccion] = useState("");
    const [experiencia, setExperiencia] = useState("");
    const [equipo, setEquipo] = useState("");

    const [numeroLic, setNumeroLic] = useState("");
    const [tipoLic, setTipoLic] = useState("");
    const [vigencia, setVigencia] = useState("");
    const [edoEmisorISO, setEdoEmisorISO] = useState("");
    const [edoEmisor, setEdoEmisor] = useState("");
    const [similarity, setSimilarity] = useState("");
    const [numImagenCompetencia, setNumImagenCompetencia] = useState("");
    const [imagenLogoDPRStr, setImagenLogoDPRStr] = useState("");
    const [carLogisticStr, setCarLogisticStr] = useState("");
    const [checkDeepBlueStr, setCheckDeepBlueStr] = useState("");

    const [experienciaRes, setExperienciaRes] = useState("");
    const [capacidadRes, setCapacidadRes] = useState("");
    const [competencia, setCompetencia] = useState("");
    const [conocimiento, setConocimiento] = useState("");
    const [alcohol, setAlcohol] = useState("");
    const [fatiga, setFatiga] = useState("");
    const [peatones, setPeatones] = useState("");
    const [interseccion, setInterseccion] = useState("");

    const [showTendencia, setShowTendencia] = useState(false);
    const [emiteTxt, setEmiteTxt] = useState("");
    const [listActividad, setListActividad] = useState([]);
    const [ingresoMensual, setIngresoMensual] = useState("");
    const [tendenciaBl, setTendenciaBl] = useState(false);
    const [listaLaboralBl, setListaLaboralBl] = useState(false);
    const [nombreComprobante, setNombreComprobante] = useState("");

    const [cardSvgP, setCardSvgP] = useState("");
    const [logoDPR, setLogoDPR] = useState("");
    const [check_deepBlue, setCheck_deepBlue] = useState("");
    const [cardSvgBlack, setCardSvgBlack] = useState("");
    const [qr, setQr] = useState("");
    const [QrData, setQrData] = useState("");
    const [QrData2, setQrData2] = useState("");

    const valorCicloAreas = 10;

    const rotateImage = (imageSrc, angle) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = imageSrc;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                if (angle === 90 || angle === 270) {
                    canvas.width = img.height;
                    canvas.height = img.width;
                } else {
                    canvas.width = img.width;
                    canvas.height = img.height;
                }

                ctx.translate(canvas.width / 2, canvas.height / 2);
                ctx.rotate((angle * Math.PI) / 180);
                ctx.drawImage(img, -img.width / 2, -img.height / 2);

                resolve(canvas.toDataURL());
            };
        });
    }

    const enhanceImage = (imageData) => {
        const data = imageData.data;
        for (let i = 0; i < data.length; i += 4) {

            const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;

            const threshold = avg > 128 ? 255 : 0;
            data[i] = data[i + 1] = data[i + 2] = threshold;
        }
        return imageData;
    };

    const decodeQRFromBase64 = (base64, documentId) => {
        const img = new Image();
        img.src = base64;

        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            imageData = enhanceImage(imageData);
            const code = jsQR(imageData.data, canvas.width, canvas.height);
            if (documentId === 1) {
                if (code) {

                    setQrData(code.data);

                } else {
                    setQrData("");
                }
            } else if (documentId === 2) {
                if (code) {
                    setQrData2(code.data);
                } else {
                    setQrData2("");
                }
            }

        };
    }

    const handleClose = () => {
        setShow(false);
    }

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            localStorage.clear();

            if (params.get("i") == null) {

                setLoading(false);
                setModalShow(false);
                setShow(true);
                setShowStatus(500);
                setShowMessage("Error al obtener el cpv")

            } else {

                setLoading(true);
                setTendenciaBl(false);

                const objCpv = {
                    cpv: params.get("i"),
                };

                const responseCpv = await mtfindCpvIdJumio(objCpv);

                if (responseCpv.status === 200) {

                    const dataImgRepo = await generarImagenReporte();

                    const cardSvgPStr =
                        "data:image/png;base64," + dataImgRepo.cardSvgP + "";

                    const logoDPRStr =
                        "data:image/png;base64," + dataImgRepo.logoDPR + "";

                    const check_deepBlueStr =
                        "data:image/png;base64," + dataImgRepo.check_deepBlue + "";

                    const cardSvgBlackStr =
                        "data:image/png;base64," + dataImgRepo.cardSvgBlack + "";

                    const qrStr =
                        "data:image/png;base64," + dataImgRepo.qr + "";


                    setLogoDPR(logoDPRStr);
                    setCardSvgP(cardSvgPStr);
                    setCheck_deepBlue(check_deepBlueStr);
                    setCardSvgBlack(cardSvgBlackStr);
                    setQr(qrStr);

                    const objCpvJum = {
                        id: responseCpv.id,
                    };


                    const response = await mtFindPersonJumio(objCpvJum);

                    if (response.status === 200) {

                        if (response.listLaboral !== null) {
                            setListActividad(response.listLaboral);
                            setListaLaboralBl(false);
                        } else {
                            setListaLaboralBl(true);
                        }

                        setCompetencia(response.aniosExperiencia);
                        setIngresoMensual(response.ingresoMensual);

                        /** ---------------------------------------------------------------------------------*/

                        const objAWSImage = {
                            img: params.get("i") + "_1.png",
                        };

                        const dataImgAWS = await testDownloadFile_Jumio(objAWSImage);

                        const imagenStrFrontID =
                            "data:image/png;base64," + dataImgAWS.img + "";


                        rotateImage(imagenStrFrontID, 360).then((rotatedImage) => {
                            setImagenFront(rotatedImage);
                        });

                        /** ---------------------------------------------------------------------------------*/

                        const objAWSImageBack = {
                            img: params.get("i") + "_2.png",
                        };

                        const dataImgAWSBack = await testDownloadFileSegundaHoja_Jumio(objAWSImageBack);

                        const imagenStrBackId =
                            "data:image/png;base64," + dataImgAWSBack.img + "";

                        rotateImage(imagenStrBackId, 360).then((rotatedImage) => {
                            setImagenBack(rotatedImage);
                        });

                        /** ----------------------------------------------------------------------------------*/

                        //------ validacion de las tendencia de las images --------------//

                        setTendenciaBl(false);

                        /************************************************************************ */

                        const responseImgLaboral = await mtfindCpvIdImgLaboral(objCpvJum);

                        const imagenLogoDPR =
                            "data:image/png;base64," + responseImgLaboral.logoDPR + "";
                        setImagenLogoDPRStr(imagenLogoDPR);

                        const imagenCarLogistic =
                            "data:image/png;base64," + responseImgLaboral.carLogistic + "";
                        setCarLogisticStr(imagenCarLogistic);

                        const imagenCheckDeepBlue =
                            "data:image/png;base64," + responseImgLaboral.checkDeepBlue + "";
                        setCheckDeepBlueStr(imagenCheckDeepBlue);

                        // Imagenes para generar el reporte 

                        const imagenCompetencia =
                            "data:image/png;base64," + responseImgLaboral.numImagenCompetencia + "";
                        setNumImagenCompetencia(imagenCompetencia);

                        /************************************************************************ */

                        setNombreComprobante(response.comprobante);
                        setCpv(response.cpv);
                        setVigenciaCpv(response.vigenciaCpv);
                        setRobos(response.robos);
                        setAccidentes(response.accidentes);

                        setConduccion(response.conduccion);
                        setDistancias(response.distancias);
                        setExperiencia(response.experiencia);
                        setEquipo(response.equipo);
                        setNumeroLic(response.numeroLic);
                        setTipoLic(response.tipoLic);
                        setVigencia(response.vigencia);
                        setEdoEmisorISO(response.edoEmisorISO);
                        setEdoEmisor(response.edoEmisor);
                        setSimilarity(response.similarity);

                        setExperienciaRes(response.experienciaRes);
                        setCapacidadRes(response.capacidad);

                        setConocimiento(response.conocimiento);
                        setAlcohol(response.alcohol);
                        setFatiga(response.fatiga);
                        setPeatones(response.peatones);
                        setInterseccion(response.interseccion);
                        setEmiteTxt(response.textoFooter);

                        if (response.numImageTendencia === 1) {
                            setShowTendencia(true);
                        } else {
                            setShowTendencia(false);
                        }

                        handlePrint();

                    } else {

                        setLoading(false);
                        setShow(true);
                        setShowStatus(response.status);
                        setShowMessage(response.message);

                    }

                } else {

                    setLoading(false);
                    setShow(true);
                    setShowStatus(responseCpv.status);
                    setShowMessage(responseCpv.message);

                }

                setLoading(false);

            }
        }

        createSession();

    }, []);


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        print: async () => {
            const doc = new jsPDF();
            doc.html(componentRef.current, {
                html2canvas: {
                    removeContainer: true,
                    scale: 0.19
                },
                margin: 5,
                x: -1,
                async callback(doc) {
                    await doc.save('Laboral_' + cpv + '_' + formattedDate);
                },
            });
        },

    });

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleClose}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>


            <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
                <div
                    className=" animate__animated animate__fadeIn"
                    ref={componentRef}
                    style={{ display: "flex", width: "1070px", border: "none" }}
                >
                    <div className="relativeCSS">
                        <style type="text/css" media="print">
                            {
                                "@page {  size: A4;  }"
                            }
                        </style>
                        {/* hoja 1 */}
                        <br />
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <article className="identify-card ">
                                        <aside className="account-detail gray w25">
                                            <section className="detail-image">
                                                <img src={logoDPR} alt="" />
                                            </section>
                                            <div className="detail-background">
                                                <img src={cardSvgP} alt="" width={'75%'} height={'auto'} />
                                            </div>
                                        </aside>
                                        <article className="middle-section">
                                            <title className="title">
                                                <div className="left">IDe</div>
                                                <div className="right">
                                                    <strong>IDENTIDAD ELECTRÓNICA</strong>
                                                    <br />
                                                    <span>CREDENCIAL VERIFICABLE</span>
                                                </div>
                                            </title>
                                            <section className="info-section gray">
                                                <div className="subtitle">
                                                    <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                                                    <h2>Identidad</h2>
                                                    <h4>Nivel 5</h4>
                                                </div>
                                                <hr className="bordeHr" />
                                                <ul className="pNone">
                                                    <li>
                                                        <img src={checkDeepBlueStr} alt="checkBlue" />
                                                        <span className="f12">Información Requerida</span>
                                                    </li>
                                                    <li>
                                                        <img src={checkDeepBlueStr} alt="checkBlue" />
                                                        <span className="f12">Documentación Probatoria</span>
                                                    </li>
                                                </ul>
                                                <div className="expires">
                                                    <span className="text-lg">Vence: {vigenciaCpv}</span>
                                                </div>
                                            </section>
                                        </article>
                                        <article className="right-section">
                                            <div className="detail-finance identity">
                                                <img src={cardSvgBlack} alt="" className="w50px" />
                                            </div>
                                            <section className="qr-code">
                                                <img className=" w50px" src={qr} alt="" />
                                                <span className="cpv__text">CPV&nbsp;: {cpv}</span>
                                            </section>
                                            <section className="verify">
                                                <img src={cardSvgP} alt="" />
                                            </section>
                                        </article>

                                    </article>
                                    <div className="text-one">
                                        <div className="textInfo f12">
                                            <b>ATENCIÓN:</b> El resultado obtenido <b>no es válido </b>si la fecha
                                            en la parte superior izquierda de este <b>Reporte</b> se
                                            encuentra <b>vencida.</b> Para comprobar su autenticidad escanee
                                            el código QR y/o ingrese directamente el código CPV en
                                            <b>&nbsp; www.midpr.net/verificar.</b>
                                        </div>
                                    </div>
                                    <div className="textNotifique">
                                        *Notifique si este Reporte es falso al +52 5571605526 y/o en
                                        www.midpr.net
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="titleCard text-center">
                                        Autenticación &nbsp; Laboral
                                    </div>
                                    <div className="subTitleCardTwo f12">
                                        Este &nbsp; Reporte da constancia de la recopilación y corroboración de información de manera completa y concluyente de esta Identidad Electrónica (IDe) elaborada por el
                                        Aplicante, obteniendo los siguientes datos:
                                    </div>
                                    <br />
                                    <div className="titleCard">RESULTADO &nbsp; OBTENIDO</div>
                                    <div className="containerCardTwo">

                                        <div className="centerButton">
                                            <div className="result">
                                                <div className="graph-half-circle">
                                                    <div
                                                        className="image-graph position-relative"
                                                    >
                                                        <img
                                                            src={numImagenCompetencia}
                                                            style={{ width: "50%", height: "auto" }}
                                                        />
                                                        <span className="percent-graph percentGraph">
                                                            {competencia}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-center  align-items-center">
                                                    <button type="button" className="inter">AÑOS DE &nbsp; EXPERIENCIA</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="textNotifique">
                                        *La interpretación de este resultado obtenido es
                                        responsabilidad exclusiva de quien lo recibe.
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <div className="titleCard">
                                        DOCUMENTACIÓN &nbsp; PROBATORIA
                                    </div>
                                    <div className="card">

                                        <div className="f12">
                                            Nombre: {nombreComprobante} <br />
                                        </div>

                                        <div className="f12">
                                            <br />

                                        </div>


                                    </div>

                                    <br />

                                    <div className="buttonCenter">

                                        {!tendenciaBl ? (
                                            <>
                                                <div className="d-flex justify-content-center  align-items-center">
                                                    <button type="button" className="btn green trend">
                                                        TENDENCIA &nbsp; A CONSISTENTE
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="d-flex justify-content-center  align-items-center">
                                                    <button type="button" className="btn yellow trend">
                                                        TENDENCIA &nbsp; A INCONSISTENTE
                                                    </button>
                                                </div>
                                            </>
                                        )}

                                    </div>
                                    <br />
                                    <div className="f12--sizing text-center">
                                        *Consulte definiciones de estas métricas en www.midpr.net/resultados.
                                    </div>

                                </div>

                                <div className="col-6">
                                    <div className="titleCard">
                                        ÁREAS &nbsp; EVALUADAS
                                    </div>
                                    <div className="card evaluated-areas tipo-d borderCard">


                                        {!listaLaboralBl ? (
                                            <>
                                                {listActividad.map((actividad, index) => (
                                                    <div key={index}>
                                                        <div className="f12 mt-2">
                                                            Ocupación: <b>Empleado</b><br />
                                                            Puesto: {actividad.puesto} <br />
                                                            Organización: {actividad.organizacion} <br />
                                                            {actividad.actual ? (
                                                                <>
                                                                    Periodo: {actividad.fechaInicio} / - <br />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    Periodo: {actividad.fechaInicio} / {actividad.fechaFin}<br />
                                                                </>
                                                            )}
                                                            Lugar: {actividad.estado} / {actividad.pais} <br />
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        ) : (
                                            <>
                                                <div className="infoData">
                                                    Ocupación: N/A <br />
                                                    Puesto: N/A <br />
                                                    Organización: N/A  <br />
                                                    Periodo: N/A <br />
                                                    Lugar: N/A  <br />
                                                </div>
                                            </>
                                        )}

                                    </div>
                                    <div className="textNotifique">
                                        *Consulte al reverso de este Reporte las imágenes recabadas
                                    </div>
                                </div>

                                {QrData && <p className="P_textQr" >{QrData}</p>}

                                {QrData2 && <p className="P_textQr" >{QrData2}</p>}

                            </div>
                        </div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <br />
                                    <div className="subTitleCardTwo f12">
                                        Esta <b>IDe</b> fue realizada de manera automatizada a través de un dispositivo digital propiedad
                                        del <b>Aplicante.</b> Durante el proceso, se registraron una serie de datos de carácter personal
                                        que fueron analizados, validados y/o verificados que permitieron, posterior al análisis de la
                                        información, la obtención del dictamen presentado con respecto a la <b>consistencia &nbsp; o &nbsp; inconsistencia &nbsp;</b>
                                        de estos de manera integral.
                                    </div>
                                </div>

                            </div>
                            <div className="note-gray note-emit">
                                <p>
                                    {emiteTxt}
                                </p>
                            </div>
                            <div className="textNotifique">
                                *Consulte al reverso de este Reporte nuestra Política de Privacidad y/o en www.midpr.net/privacidad
                            </div>
                            <br />
                            <div className="titleCard">AVISO &nbsp; LEGAL</div>
                            <div className="card legal-advise borderCard">
                                <div className="subTitleCardTwo f12">
                                    <p>
                                        La <strong>Calificación</strong> realizada de manera
                                        remota por el <strong>Aplicante</strong>, a la que hace
                                        referencia este <strong>Reporte</strong>, fue realizada
                                        a solicitud directa del <strong>Destinatario</strong>.
                                        Antes y durante la <strong>Calificación &nbsp;</strong>, fue
                                        autenticada la identidad del <strong>Aplicante</strong>{" "}
                                        y se registraron una serie de datos e información de
                                        carácter personal con su autorización expresa &nbsp;, lo cual
                                        permitió emitir una Evaluación Remota Confiable (&nbsp; ERC &nbsp;).
                                        El <strong>Destinatario</strong> acepta que todos los
                                        datos contenidos en el presente <strong>Reporte</strong>{" "}
                                        son confidenciales y de interés exclusivo y privado, que
                                        es compartida únicamente con el propósito que ha sido
                                        previamente informado por el{" "}
                                        <strong>Destinatario</strong> y que ha autorizado por el{" "}
                                        <strong>Aplicante</strong> previo a la aplicación de la{" "}
                                        <strong>Calificación &nbsp;</strong>. El{" "}
                                        <strong>Aplicante</strong> y/o el{" "}
                                        <strong>Destinatario</strong> de este Reporte aceptan de
                                        conformidad la responsabilidad sobre cualquier uso
                                        indebido o ilegal de este documento y su contenido, así
                                        como todos los términos y condiciones descritos al
                                        reverso.{" "}
                                        <strong>
                                            Una vez entregado este Reporte al Destinatario, el
                                            Fabricante se deslinda de toda responsabilidad sobre
                                            su interpretación, divulgación y uso
                                        </strong>
                                        .
                                    </p>
                                </div>
                            </div>
                            <div className="textNotifique f12">
                                <b>Business &nbsp; Prey SA</b> de <b>CV</b> hace referencia que con número de
                                registro DGSP&nbsp;/369-19/3919, está autorizada por la SSPC&nbsp;/DGSP
                                para la aplicación de Pruebas y Evaluación &nbsp; de Control de
                                Confianza de conformidad con los Lineamientos y Criterios
                                Técnicos &nbsp; publicados en el Diario Oficial de la Federación
                                (DOF) el 28 de abril de 2020.
                            </div>
                            <div style={{ paddingTop: "", background: "#FFF" }}>
                            </div>
                        </div>
                        <br />
                        <br />

                        {/* hoja 2 */}
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />

                        <div className="div-vertical mt-15">
                            <div className="div-horizontal" id="div1">

                                <br />
                                <br />
                                <br />
                                <div className="Documetos__size--padding">
                                    <div className="titleCard">DOCUMENTOS &nbsp; PRESENTADOS</div>
                                    <div className="card presented ">

                                        <img src={imagenFront} alt="" className="w-100 newImageFormat" onLoad={() => decodeQRFromBase64(imagenFront, 1)} />

                                    </div>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <div className="card presented ">
                                        <img src={imagenBack} alt="" className="w-100 newImageFormat" onLoad={() => decodeQRFromBase64(imagenBack, 2)} />
                                    </div>
                                </div>

                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />

                                <br />

                                <br />
                                <div className="cardLeft">

                                    <div className="subTitleCardTwo f12">
                                        <b>Privacidad de Datos Personales &nbsp;</b> Para efectos del
                                        cumplimiento del artículo 9 de la Ley Federal de
                                        Protección de Datos Personales en Posesión de los
                                        Particulares (LFPDPPP &nbsp;), el Aplicante de la ERC manifiesta
                                        expresamente que otorgó su consentimiento para el
                                        tratamiento de sus datos personales sensibles, durante los
                                        procedimientos de recopilación y procesamiento, aceptando
                                        los términos y condiciones para tales efectos.
                                    </div>

                                    <div className="subTitleCardTwo f12">
                                        <b>Uso de las &nbsp; Marcas &nbsp;</b> DPR &nbsp;y las marcas asociadas son marcas
                                        registradas, protegida por los artículos 88 y 142 de la
                                        Ley de Propiedad Industrial (LPI &nbsp;), así como el convenio de
                                        París para efectos internacionales. El consumo o
                                        adquisición de cualquiera de los servicios vinculados a
                                        DPR &nbsp; y/o proporcionados por el Fabricante, no confieren al
                                        Aplicante y/o al Destinatario el derecho de uso de las
                                        marcas de DPR en ningún contexto y/o formato, ya que al
                                        hacerlo podría resultar en actividad fraudulenta y ser
                                        clasificado como un delito. La marca, propiedad
                                        intelectual o cualquier otro tipo de secreto industrial
                                        contenido en este Reporte, no autoriza el uso, explotación
                                        comercial, venta, reproducción o distribución de dicha
                                        información.
                                    </div>

                                    <div className="subTitleCardTwo f12">
                                        <b>Uso de Información por Terceros &nbsp;</b> Al realizar la ERC&nbsp; , el
                                        Aplicante autoriza la entrega del resultado obtenido al
                                        Destinatario para el uso particular que ambos hayan
                                        acordado. Para el caso exclusivo de Elementos de Seguridad
                                        Privada, la entrega de este Reporte a la DGSP, se hará
                                        conforme a lo previsto en el artículo 9 de los citados
                                        Lineamientos y Criterios Técnicos.
                                    </div>
                                </div>
                                <div>
                                    <div className="card evaluated-areas tipo-d borderCard">
                                        <div className="titleContainerSinBorder f12">
                                            TEMAS DE INTERÉS
                                        </div>
                                        <div className="subTitleCardTwo f12">
                                            <ul className="espacio-ul-left">
                                                <li>
                                                    <strong>Años de experiencia:</strong> Años laborales acumulados (derivado).
                                                </li>
                                                <li>
                                                    <strong>Historial laboral:</strong> Ocupación (recabada), puesto (recabado), organización (recabada), periodo (recabado), lugar (recabado).
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />

                                    <div className="note-gray cardLeft">
                                        <p>
                                            <strong>Business &nbsp; Prey SA de CV</strong> con domicilio en
                                            Alfonso Reyes 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es Fabricante exclusivo de
                                            DPR. Para mayor información llame al +52 5571605526 o
                                            visite el sitio <strong>www.midpr.net</strong>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default N5BLaboral_Jumio;
